export default {
	updateSettingSystem(state, res) {
		state.SettingSystem = res;
	},
	updateIsDowloadMeInvoice(state, res) {
		if (state.SettingSystem) return;
		state.SettingSystem.IsDownloadMeInvoice = res;
	}
};
